import { isAssistantEnabled } from '@agently/api';
import type { ReactElement } from 'react';
import type { RouteObject } from 'react-router';

/**
 * `/assistant` and `/assistant/:threadId`, only with VITE_ASSISTANT_URL: without it
 * they do not exist and fall to the app's NoMatch.
 */
export const createAssistantRoutes = ({
  element,
  loader,
}: {
  element: ReactElement;
  loader: NonNullable<RouteObject['loader']>;
}): RouteObject[] =>
  isAssistantEnabled
    ? [
        { element, loader, path: '/assistant' },
        { element, loader, path: '/assistant/:threadId' },
      ]
    : [];
